// extracted by mini-css-extract-plugin
export default {"shell":"k94w4Q2STxaZdCH16C5Y","row":"he5jJ9aOVQ5WhErAbirN","content":"QR_kDvjPB2KoTlafhbqy"};